import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import ReviewCard from "../utils/ReviewCard";

const Left = ({ onClick }) => (
  <div className="arrow arrow_left" onClick={onClick}>
    <svg
      version="1.1"
      id="Layer_1"
      width="0.8rem"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 492 492"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path
            d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12
C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084
c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864
l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"
          />
        </g>
      </g>
    </svg>
  </div>
);

const Right = ({ onClick }) => (
  <div className="arrow arrow_right" onClick={onClick}>
    <svg
      version="1.1"
      width="0.8rem"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 451.846 451.847"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
      L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
      c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"
        />
      </g>
    </svg>
  </div>
);

const Featured = () => {
  const [slides,setSlides] = useState(3);
  useEffect(()=>{
    setSlides(window.innerWidth> 992 ? 3 :window.innerWidth > 768 ? 2 : 1)
  },[]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: slides,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    prevArrow: <Left />,
    nextArrow: <Right />,
  };
  const data = [1,2,3,4,5,6,7,8,9]
  const showSlides = ()=>{
    return data.map((el,i)=>{
      return <ReviewCard key={i} {...data} />
    })
  }
  return (
    <section className="featured py-5">
      <div className="container px-3">
        <h1 className="text-center font-weight-bold">Featured Doctors</h1>
        <Slider {...settings} arrows={true}>
          {showSlides()}
        </Slider>
      </div>
    </section>
  );
};

export default Featured;
